import {createAsyncThunk} from '@reduxjs/toolkit';
import apiInstance from '../../Apis/Axios';
import { FOODIE_MENU_SERVICE } from '../EndPoints';

export const GetMealTimeById = createAsyncThunk('mealTime/GetMealTimeById', async (params, { dispatch, getState }) => {
    const response = await apiInstance.get(`${FOODIE_MENU_SERVICE.getMealTimeById}${params}`).then((response) => {
        return response;
    })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const CreateMealTime = createAsyncThunk("mealTime/CreateMealTime",async (params, { dispatch, getState }) => {

    const response = await apiInstance.post(FOODIE_MENU_SERVICE.createMealTime, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const UpdateMealTime = createAsyncThunk("mealTime/UpdateMealTime",async (params, { dispatch, getState }) => {

    const response = await apiInstance.put(FOODIE_MENU_SERVICE.updateMealTime, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});
